export const POINT_IN_TIME = "POINT_IN_TIME";
export const PRE_POST = "PRE_POST";
export const TREND = "TREND";
export const BUTTERLFY = "BUTTERFLY";
export const PERCEPTUAL = "PERCEPTUAL";
export const DIFFERENTIATION = "DIFFERENTIATION";
export const DISTRIBUTION = "DISTRIBUTION";
export const DEFAULT = "DEFAULT";
export const LINE = "LINE";
export const BUBBLE = "BUBBLE";
export const DONUT = "DONUT";
export const FUNNEL = "FUNNEL";
export const BAR = "BAR";
export const TABLE = "TABLE";
export const BARCODE = "BARCODE";
export const GAUGE = "GAUGE";

export const MARKETS = "markets";
export const BRANDS = "brands";
export const SECONDARY_BRANDS = "secondaryBrands";
export const FILTERS = "filters";
export const FILTERSV2 = "f";
export const SEGMENTS = "segments";

// ─── v2 filters URL grammar ───────────────────────────────────────────────────
// `fv=2` version marker + one `f=` param per FilterSelection:
//   OPTION → f=<filterCode>:<optCode>,<optCode>,...
//   RANGE  → f=<filterCode>:r=<min>-<max>
// Segments keep the existing `segments=` param.
export const FILTERS_VERSION_PARAM = "fv";
export const FILTERS_VERSION_V2 = "2";
export const FILTER_PARAM = "f";

export const QUESTION_OPTIONS = "questionOptions";
export const GROUPED_BY = "groupedBy";

export const STAT_TEST = "statTest";
export const BASE = "base";
export const MODE = "mode";
export const PERIOD_TYPE = "periodType";
export const PERIOD_START_DATE = "periodStartDate";
export const PERIOD_END_DATE = "periodEndDate";
export const POST_PERIOD_TYPE = "postPeriodType";
export const POST_START_DATE = "postStartDate";
export const POST_END_DATE = "postEndDate";

// URL-only period keys for `mode=PRE_POST`. The URL names the two windows the
// other way round from the state fields above: `prePeriod*` is the Pre window
// and the unprefixed `period*` keys are the Post window. There is no state
// field by these names — see `utils/prePostPeriodUrlKeys.ts`.
export const PRE_PERIOD_TYPE = "prePeriodType";
export const PRE_PERIOD_START_DATE = "prePeriodStartDate";
export const PRE_PERIOD_END_DATE = "prePeriodEndDate";
export const PERIOD = "period";
export const VISUALIZATION_TYPE = "visualizationType";
export const METRIC = "metric";
export const RESPONSE = "response";
export const DETAILED = "DETAILED";
export const EQUITY = "EQUITY";
export const CONVERSION = "CONVERSION";
export const ADVERTISING = "ADVERTISING";
export const EMOTIONAL = "EMOTIONAL";
export const TRENDS = "TRENDS";
export const VISIBILITY = "VISIBILITY";
export const REPUTATION = "REPUTATION";
export const QUESTIONS = "QUESTIONS";
export const COMPETITIVE = "COMPETITIVE";
export const GLOBAL = "GLOBAL";
export const ADVANCED = "ADVANCED";
export const EXPORT_PRE_POST = "PREPOST";
export const SCORE_TYPE = "scoreType";

export const PROFILE_GROUP = "profileGroup";
export const PROFILE_RESPONSE = "profileResponse";
export const PROFILE_METRIC = "profileMetric";

export const TRENDS_METRIC = "trendsMetric";
export const CATEGORY = "category";
export const HUMAN_METRIC = "humanMetric";
/**
 * Legacy singular URL query key for selected AI models (`model=1&model=2`).
 * No longer emitted — the canonical key is MODELS ("models") — but still
 * accepted on parse so old/shared links keep working.
 */
export const MODEL = "model";
/**
 * URL query key for selected AI models (`models=1&models=2`), and the
 * matching `userSelection` / API field holding the selected model id list.
 */
export const MODELS = "models";
export const AI_VISIBILITY = "AI_VISIBILITY";
export const VIEW_ID = "viewId";
export const MAXIMUM_ALLOWED_QUESTIONS_IN_TRENDS = 1;
export const MAXIMUM_ALLOWED_QUESTIONS = 30;
export const CLIENT_KEY = "clientKey";
export const REPUTATION_START_DATE = "2025-11-17";
export const ADVERTISING_START_DATE = "2022-09-21";
export const REDIRECT_URL = "redirectUrl";

export const URL_BY_BRAND = "brand";
export const URL_BY_SEGMENT = "segment";
export const URL_BY_MARKET = "market";
export const URL_BY_MODEL = "model";

export const STORING_SCREEN_LEVEL_CONTEXT_FOR_MODE_AND_VISUALIZATION: string[] =
  [PRE_POST, BUTTERLFY, DIFFERENTIATION];
